export class LoanTransactions {
  constructor() {
    this.items = [];
  }

  /**
   * @param {LoanTransaction} loanTransaction
   */
  add(loanTransaction) {
    this.items.push(loanTransaction)
  }

  /**
   * @param {float} totalCost
   * @returns {string|number}
   */
  totalPercentage(totalCost) {
    if (typeof totalCost !== undefined) {
      let totalAmount = 0;
      if (this.items.length > 0) {
        this.items.forEach((payment) => {
            totalAmount += payment.amount
        })
      }

      return ((totalAmount / totalCost) * 100).toFixed(2)
    }
    return 0
  }
}
